<div class="flex items-center justify-center min-h-screen bg-white">
    <div class="flex flex-col items-center">
        <div class="w-full flex justify-center my-6">
            <img src="/assets/images/auth/interseed-new-logo.png" alt="interseed logo" class="h-16 w-auto" />
        </div>

        <div class="text-center mt-6">
            <p class="text-[#0A0A0A] text-[1.5rem]">Reset password</p>
            <p class="text-[#717182] text-[0.9rem] mt-2">Create your new password</p>
        </div>

        <form [formGroup]="resetPasswordForm" (ngSubmit)="submit()">
            <div class="w-full max-w-[500px] sm:min-w-[400px] rounded-2xl my-6 px-4 py-6 drop-shadow-black">
                <div class="flex flex-col mb-4 space-y-2">
                    <label for="password" class="text-[0.875rem] text-[#0A0A0A]">New Password</label>
                    <div class="relative">
                        <input
                            id="password"
                            formControlName="password"
                            placeholder="Create strong password"
                            class="w-full form-field-container pr-10"
                            [type]="showPassword ? 'text' : 'password'" />
                        <img
                            alt="Toggle password visibility"
                            class="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 cursor-pointer"
                            [src]="
                                showPassword ? '/assets/images/auth/eye-hide.svg' : '/assets/images/auth/eye-show.svg'
                            "
                            (click)="togglePasswordVisibility()" />
                    </div>
                    @if (resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched) {
                        <div class="text-[#717182] text-[0.625rem]">Must be at least 8 characters</div>
                    }
                </div>

                <div class="flex flex-col mb-4 space-y-2">
                    <label for="confirmPassword" class="text-[0.875rem] text-[#0A0A0A]">Confirm Password</label>
                    <div class="relative">
                        <input
                            id="confirmPassword"
                            formControlName="confirmPassword"
                            placeholder="Confirm your password"
                            class="w-full form-field-container pr-10"
                            [type]="showPassword ? 'text' : 'password'" />
                        <img
                            alt="Toggle password visibility"
                            class="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 cursor-pointer"
                            [src]="
                                showPassword ? '/assets/images/auth/eye-hide.svg' : '/assets/images/auth/eye-show.svg'
                            "
                            (click)="togglePasswordVisibility()" />
                    </div>
                    @if (resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched) {
                        <div class="text-[#717182] text-[0.625rem]">Must be at least 8 characters</div>
                    }
                </div>

                <div class="flex flex-col mb-4">
                    <p class="text-[#717182] text-[0.875rem] mb-3">Password must have:</p>
                    <div class="flex flex-col gap-y-2">
                        <div class="flex items-center gap-2">
                            <img
                                [ngClass]="hasMinLength() ? 'check-icon' : 'cross-icon'"
                                [src]="
                                    hasMinLength() ? '/assets/images/auth/check.svg' : '/assets/images/auth/cross.svg'
                                "
                                [alt]="hasMinLength() ? 'check icon' : 'cross icon'" />
                            <p
                                [class]="
                                    hasMinLength() ? 'text-[#00A63E] text-[0.875rem]' : 'text-[#717182] text-[0.875rem]'
                                ">
                                At least 8 characters in length
                            </p>
                        </div>
                        <div class="flex items-center gap-2">
                            <img
                                [ngClass]="hasNumber() ? 'check-icon' : 'cross-icon'"
                                [src]="hasNumber() ? '/assets/images/auth/check.svg' : '/assets/images/auth/cross.svg'"
                                [alt]="hasNumber() ? 'check icon' : 'cross icon'" />
                            <p
                                [class]="
                                    hasNumber() ? 'text-[#00A63E] text-[0.875rem]' : 'text-[#717182] text-[0.875rem]'
                                ">
                                At least 1 number
                            </p>
                        </div>
                        <div class="flex items-center gap-2">
                            <img
                                [ngClass]="hasLetter() ? 'check-icon' : 'cross-icon'"
                                [src]="hasLetter() ? '/assets/images/auth/check.svg' : '/assets/images/auth/cross.svg'"
                                [alt]="hasLetter() ? 'check icon' : 'cross icon'" />
                            <p
                                [class]="
                                    hasLetter() ? 'text-[#00A63E] text-[0.875rem]' : 'text-[#717182] text-[0.875rem]'
                                ">
                                At least 1 lower or upper case letter
                            </p>
                        </div>
                    </div>
                </div>
                <button type="submit" class="w-full border-button" [disabled]="resetPasswordForm.invalid">
                    Reset Password
                </button>
            </div>
        </form>
    </div>
</div>
